/**
 * Created by christiancueni on 23/05/18.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import {Injectable} from '@angular/core';
import { Store } from "@ngrx/store";

import * as fromAuth from "../reducers";
import { UiSetLanguage } from "../actions/ui";
import { IS_APP } from "../app.constants";

declare global {
    interface Navigator {
        globalization:any
    }
}

const DE_LANG = 'de'
const FR_LANG = 'fr'
const IT_LANG = 'it'

@Injectable()
export class LocalizationService {

    constructor(private store: Store<fromAuth.AppState>) {
    }

    setLanguageForApp() {
        if (IS_APP) {
            document.addEventListener('deviceready', this.onReady.bind(this), false);
        }
    }

    private onReady() {
        navigator.globalization.getPreferredLanguage(
            (language) => {
                const langParts = language.value.split('-');
                let languageId = DE_LANG;
                if (langParts.length > 1) {
                    languageId = this.determineLanguage(langParts[0])
                }
                this.store.dispatch(new UiSetLanguage(`${languageId}`));
            },
            () => {
                this.store.dispatch(new UiSetLanguage(DE_LANG));
            }
        );
    }

    setLanguage(userLang:string) {
        if (IS_APP) {
            document.addEventListener('deviceready', this.onReady.bind(this), false);
        } else {
            this.setLanguageForWeb(userLang)
        }
    }

    private setLanguageForWeb(userLang:string) {
        if(!userLang) {
            userLang = DE_LANG;
        }

        try {
            if (navigator['languages'] && navigator['languages'].length > 0) {
                userLang = navigator['languages'][0];
            } else {
                userLang = navigator.language;
            }
            const languageId = this.determineLanguage(userLang)
            this.store.dispatch(new UiSetLanguage(languageId));
        } catch(e) {
            this.store.dispatch(new UiSetLanguage(DE_LANG));
        }
    }

    private determineLanguage(userLang) {
        if (userLang.indexOf(FR_LANG) !== -1) {
            return FR_LANG;
        } else if (userLang.indexOf(IT_LANG) !== -1) {
            return IT_LANG;
        } else {
            return DE_LANG
        }
    }

}
